import '../application';
import banner from 'sbf-design-system-component/banners/banner';
import 'sbf-design-system-component/forms/base';
import 'sbf-design-system-component/accordions/accordion';
import 'sbf-design-system/js/lib/parsley';
import 'lib/country-state-updater';

const dataIsoCompliantCountries = $('#country_code').data('iso-compliant-countries');

window.recaptcha_callback = function () {
  $('#webToLead .recaptcha-error-message').remove();
};

$('#webToLead .sbf-button').on('click', (event) => {
  // If in page edit mode.
  if (window.sbf.ce && window.sbf.ce.init) {
    return;
  }
  // Form field validation check.
  if (!validateFields()) {
    event.preventDefault();
    scrollFocusToFirstInvalidInput();
    return;
  }

  if ($('#company').val().trim() === '') {
    $('#company').closest('.inline-input').removeClass('empty');
    // Custom Logic SBF Requested - Don't Remove
    $('#company').val('Individual');
  }
});

const scrollFocusToFirstInvalidInput = () => {
  $('.invalid:first').find('input, select, textarea').focus();

  if (!window.navigator.userAgent.match(/iPad|iPhone/i)) {
    $('html, body').animate({ scrollTop: $('.invalid:first').offset().top - 150 }, 300, () => {});
  }
};

const validateFields = () => {
  let requiredsValid = true;

  $('#webToLead').find('[required]:visible').each((_i, el) => {
    if (!validateField(el)) {
      $(el).closest('.inline-input').addClass('invalid');
      requiredsValid = false;
    } else {
      $(el).closest('.inline-input').removeClass('invalid');
    }
  });

  if (!requiredsValid) {
    banner.showError($('.invalid:first').find('input, select, textarea').attr('data-parsley-error-message'), false, 4000);
    if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha) {
      window.grecaptcha.reset();
    }
    return false;
  }

  if (window.grecaptcha) {
    if (!$('#g-recaptcha-response').val()) {
      banner.showError('Please verify that you are not a robot.', false, 4000);
      $('#webToLead .recaptcha-error-message').remove();
      $('#webToLead .g-recaptcha').after('<div class="recaptcha-error-message inline-input invalid">Please verify that you are not a robot.</div>');
      window.grecaptcha.reset();
      return false;
    }
  }

  return true;
};

const validateField = (el) => {
  let valid = true;

  // special field checks first
  if (el.name === 'phone') {
    if (!validatePhoneNumber(el.value)) {
      valid = false;
    }
  }

  if (!valid || !$(el).parsley().isValid(true)) {
    return false;
  }
  return true;
};

const validatePhoneNumber = (mightBeAPhoneNumber) => {
  // strip anything that's not a digit and make sure there are 10 or more of what's left
  const onlyNumbers = mightBeAPhoneNumber.replace(/[^0-9]/g, '');
  // not requiring area code currently
  return onlyNumbers.length >= 7;
};

// Custom Logic SBF Requested - Don't Remove
$('.inline-input__select--reason').on('change', function () {
  if ($(this).val() === 'Opt out SMS Text') {
    $('.checkbox-container--opt-in').hide();
  } else {
    $('.checkbox-container--opt-in').show();
  }
});

$('#country_code').on('change', function () {
  const wrap = $('#country_code').closest('.flex-container');
  if (!dataIsoCompliantCountries.includes($(this).val())) {
    $('#states_container').hide();
    $('#state_code').removeAttr('required');
    wrap.addClass('no-state-field');
  } else {
    $('#states_container').show();
    $('#state_code').attr('required', 'required');
    wrap.removeClass('no-state-field');
  }
}).change();
